import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Input,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalHeader
} from 'reactstrap';
import { connect } from 'react-redux';
import { IEncaissementScanModal } from '../../types/interfaces';

import { getFtpCheck } from '../../flux/actions/encaissementActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faFileInvoice, faMoneyCheck, faPrint, faRedo, faSpinner, faUndo } from '@fortawesome/free-solid-svg-icons'
import { useReactToPrint } from 'react-to-print';

import Loading from '../Loading';

const EncaissementScanModal = ({ 
  modal,
  setModal,
  modalEncaissement,
  setModalEncaissement
 }: IEncaissementScanModal) => {
  const [rectoImg, setRectoImg] = useState('');
  const [versoImg, setVersoImg] = useState('');
  const [rectoLoading, setRectoLoading] = useState(false);
  const [versoLoading, setVersoLoading] = useState(false);
  const [imagesCache, setImagesCache] = useState<any[]>([]);
  const rectoRef = useRef<any>(null);
  const versoRef = useRef<any>(null);
  const [isRotating, setIsRotating] = useState(false);
  const [disableRectoPrint, setDisableRectoPrint] = useState(false);
  const [disableVersoPrint, setDisableVersoPrint] = useState(false);

  const handleToggle = () => setModal(!modal);

  const modalOpenedHandle = async () => {
    if(modalEncaissement && modalEncaissement !== ''){
      let rectoPath = null,
          versoPath = null,
          rectoIsAbsolutePath = 0,
          versoIsAbsolutePath = 0;
      if(modalEncaissement["recto_name"])
        rectoPath = modalEncaissement["recto_name"]
      else if(modalEncaissement["URL"]){
        rectoPath = modalEncaissement["URL"]
        rectoIsAbsolutePath = 1;
      }
      if(modalEncaissement["verso_name"])
        versoPath = modalEncaissement["verso_name"]
      else if(modalEncaissement["URL_VERSO"]){
        versoPath = modalEncaissement["URL_VERSO"]
        versoIsAbsolutePath = 1;
      }
      if(rectoPath){
        const cachedRectoImg = imagesCache.find(e => e.name === rectoPath);
        if(!!cachedRectoImg)
          setRectoImg(cachedRectoImg.image ? ("data:image/jpeg;base64," + cachedRectoImg.image) : "")
        else{
          setRectoLoading(true);
          const rectoFtpCheck = await getFtpCheck(rectoPath, rectoIsAbsolutePath);
          setRectoLoading(false);
          setRectoImg(rectoFtpCheck?.data ? ("data:image/jpeg;base64," + rectoFtpCheck?.data) : "");
          setImagesCache(e => [...e, {name: rectoPath, image: rectoFtpCheck?.data || ''}]);
        }
      }
      else
        setRectoImg('')
      if(versoPath){
        const cachedVersoImg = imagesCache.find(e => e.name === versoPath);
        if(!!cachedVersoImg)
          setVersoImg(cachedVersoImg.image ? ("data:image/jpeg;base64," + cachedVersoImg.image) : "")
        else{
          setVersoLoading(true);
          const versoFtpCheck = await getFtpCheck(versoPath, versoIsAbsolutePath);
          setVersoLoading(false);
          setVersoImg(versoFtpCheck?.data ? ("data:image/jpeg;base64," + versoFtpCheck?.data) : "");
          setImagesCache(e => [...e, {name: versoPath, image: versoFtpCheck?.data || ''}]);
        }
      }
      else
        setVersoImg('')
    }
    else{
      setRectoImg("");
      setVersoImg("");
    }
  };

  const modalClosedHandle = () => {
    setModalEncaissement('');
    setRectoImg('');
    setVersoImg('');
  };

  const rotateImg = (base64: string, degrees: number, setImg: Function) => {
    if(isRotating)
      return
    setIsRotating(true);
    const image = new Image();
    image.src = base64;
    image.onload = function() {
      const canvas = document.createElement("canvas");
      const w = image.width;
      const h = image.height;
      const rads = degrees * Math.PI/180;
      let c = Math.cos(rads);
      let s = Math.sin(rads);
      if (s < 0) { s = -s; }
      if (c < 0) { c = -c; }
      //use translated width and height for new canvas
      canvas.width = h * s + w * c;
      canvas.height = h * c + w * s;
      //draw the rect in the center of the newly sized canvas
      const ctx = canvas.getContext("2d");
      if(ctx){
        ctx.translate(canvas.width/2, canvas.height/2);
        ctx.rotate(degrees * Math.PI / 180);
        ctx.drawImage(image, -image.width/2, -image.height/2);
        setImg(canvas.toDataURL("image/jpeg"));
        setIsRotating(false);
      }
    };
  }

  const printPageStyle = `
    @page {
      size: auto;
      margin: 0mm;
    }
    @media print {
      body {
        -webkit-print-color-adjust: exact;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .scanPreview {
        max-height: 100%;
        margin: 0;
        padding: 10px;
      }
    }
  `;

  const printHookRecto = useReactToPrint({
    content: () => rectoRef.current,
    pageStyle: printPageStyle
  });

  const printHookVerso = useReactToPrint({
    content: () => versoRef.current,
    pageStyle: printPageStyle
  });

  const printHandle = (printHook, setDisablePrint) => {
    if(printHook){
      setDisablePrint(true);
      printHook();
      setTimeout(() => setDisablePrint(false), 2000);
    }
  }

  const downloadImg = (base64: string, fileNameStart: string) => {
    const datetimeAsText = new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear() + '_' + new Date().getHours() + '-' + new Date().getMinutes() + '-' + new Date().getSeconds();
    try{
      const downloadLink = document.createElement("a");
      downloadLink.href = base64;
      downloadLink.download = `${fileNameStart}_${datetimeAsText}`;
      downloadLink.click();
    }
    catch(e){
      console.error("error downloading enc image")
    }
  }

  return (
    <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle} className="modal-dialog-large">
      <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faMoneyCheck} />&nbsp;&nbsp;Aperçu des Scans{modalEncaissement && modalEncaissement["REF_REGLEMENT"] ? (" - " + modalEncaissement["REF_REGLEMENT"]) : ""}</ModalHeader>
      <ModalBody>
        <Container className="scanPreviewContainer">
          {rectoImg || rectoLoading ? <Row>
            <Col xs="12">Recto</Col>
            <Col xs="12">{rectoLoading ? <Loading /> : 
            // <img className="scanPreview" src={rectoImg}/>
            <div className="scanPreviewBtnsAndImgContainer">
              <img className="scanPreview" ref={rectoRef} src={rectoImg}/>
              <div className="scanPreviewBtnsContainer">
                <button onClick={() => rotateImg(rectoImg, -90, setRectoImg)} title="Faire pivoter vers la gauche"><FontAwesomeIcon icon={faUndo} /></button>
                <button onClick={() => rotateImg(rectoImg, 90, setRectoImg)} title="Faire pivoter vers la droite"><FontAwesomeIcon icon={faRedo} /></button>
                <button onClick={() => printHandle(printHookRecto, setDisableRectoPrint)} title="Imprimer" disabled={disableRectoPrint}><FontAwesomeIcon icon={disableRectoPrint ? faSpinner : faPrint} className={disableRectoPrint ? "spinner" : ""} /></button>
                <button onClick={() => downloadImg(rectoImg, `${(modalEncaissement["REF_REGLEMENT"] || "sans_ref")}_recto`)} title="Télécharger"><FontAwesomeIcon icon={faDownload} /></button>
              </div>
            </div>
            }</Col>
          </Row> : null}
          {versoImg || versoLoading ? <Row>
            <Col xs="12">Verso</Col>
            <Col xs="12">{versoLoading ? <Loading /> : 
            // <img className="scanPreview" src={versoImg}/>
            <div className="scanPreviewBtnsAndImgContainer">
              <img className="scanPreview" ref={versoRef} src={versoImg}/>
              <div className="scanPreviewBtnsContainer">
                <button onClick={() => rotateImg(versoImg, -90, setVersoImg)} title="Faire pivoter vers la gauche"><FontAwesomeIcon icon={faUndo} /></button>
                <button onClick={() => rotateImg(versoImg, 90, setVersoImg)} title="Faire pivoter vers la droite"><FontAwesomeIcon icon={faRedo} /></button>
                <button onClick={() => printHandle(printHookVerso, setDisableVersoPrint)} title="Imprimer" disabled={disableVersoPrint}><FontAwesomeIcon icon={disableVersoPrint ? faSpinner : faPrint} className={disableVersoPrint ? "spinner" : ""} /></button>
                <button onClick={() => downloadImg(versoImg, `${(modalEncaissement["REF_REGLEMENT"] || "sans_ref")}_verso`)} title="Télécharger"><FontAwesomeIcon icon={faDownload} /></button>
              </div>
            </div>
            }</Col>
          </Row> : null}
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default connect(null, {})(EncaissementScanModal);
